import { useEffect } from 'react';

import { useLocation } from 'react-router';

export const usePageTitle = (title: string) => {
  const location = useLocation();

  useEffect(() => {
    document.title = `Админ панель - ${title}`;
  }, [location, title]);
};
